import React, { useEffect, useState } from "react";
import {
  CardContent,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../LoadingSpinner";
import {
  useGetAllWorkflowsQuery,
  useGetAllTeamsSelectedWorkflowIdQuery,
  useGetLatestStatusReportQuery,
} from "../../../../Services/reports/tickets/ReportTickets";
import { toast } from "react-toastify";
import CsvDownloader from "react-csv-downloader";
import { MultiSelect } from "react-multi-select-component";

const LatestStatusReport1 = () => {
  const navigate = useNavigate();
  const {
    data: workflowsData,
    error: workflowsError,
    isLoading: workflowsLoading,
  } = useGetAllWorkflowsQuery({});
  const [selectedWorkflowId, setSelectedWorkflowId] = useState<string | null>(
    null,
  );
  const [params, setParams] = useState<any>(null);
  const [optionsTeams, setOptionsTeams] = useState<any[]>([]);
  const [optionsWorkflow, setOptionsWorkflow] = useState<any[]>([]);
  const [selectedTeams, setSelectedTeams] = useState<any>([]);
  const [selectedTeamsParam, setSelectedTeamsParam] = useState<string[]>([]);
  const [dateFrom, setDateFrom] = useState<string>("");
  const [dateTo, setDateTo] = useState<string>("");
  const [selectedStatus, setSelectedStatus] = useState<any[]>([]);
  const [dataRows, setDataRows] = useState<any[]>([]);
  const [columns, setColumns] = useState<any>([]);
  const [localLoading, setLocalLoading] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });

  const { data: teamData, isLoading: teamLoading } =
    useGetAllTeamsSelectedWorkflowIdQuery(selectedWorkflowId, {
      skip: !selectedWorkflowId,
    });

  const { data: latestStatusReportReport, error } =
    useGetLatestStatusReportQuery(params, {
      skip: !params,
    });
  const [loading, setLoading] = useState(false);

  const handleDownloadClick = () => {
    setLoading(true);

    // Simulate the completion of the download after interaction
    setTimeout(() => {
      setLoading(false);
    }, 1000); // Adjust or remove this delay as needed
  };

  const optionsStatus: any[] = [
    { label: "Active", value: "active" },
    { label: "Closed", value: "closed" },
    { label: "Reopen", value: "reopen" },
    { label: "In Progress", value: "wip" },
  ];

  useEffect(() => {
    if (teamData && teamData.results?.length > 0) {
      const transformedOptions = teamData.results.map((team: any) => ({
        label: team.team_name,
        value: team.id,
      }));
      setOptionsTeams(transformedOptions);
    }
  }, [teamData]);

  useEffect(() => {
    if (workflowsData && workflowsData.results?.length > 0) {
      const transformedOptions = workflowsData.results.map((workflow: any) => ({
        label: workflow.workflow_name,
        value: workflow.id,
      }));
      setOptionsWorkflow(transformedOptions);
    }
  }, [workflowsData]);
  console.log("workflowsData", workflowsData);
  console.log("optionsWorkflow", optionsWorkflow);

  useEffect(() => {
    const isDate = (value) => {
      if (typeof value !== "string") return false;

      // More flexible date patterns
      const datePatterns = [
        /^\d{4}-\d{1,2}-\d{1,2}$/, // YYYY-M-D or YYYY-MM-DD
        /^\d{4}-\d{1,2}-\d{1,2} \d{1,2}:\d{1,2}(?::\d{1,2})?$/, // YYYY-M-D H:MM:SS or variations
        /^\d{4}-\d{1,2}-\d{1,2}T\d{1,2}:\d{1,2}(?::\d{1,2})?/, // ISO format with flexible time
        /^\d{1,2}\/\d{1,2}\/\d{4}$/, // D/M/YYYY or DD/MM/YYYY
        /^\d{4}\/\d{1,2}\/\d{1,2}$/, // YYYY/M/D or YYYY/MM/DD
      ];

      return (
        datePatterns.some((pattern) => pattern.test(value)) &&
        !isNaN(Date.parse(value))
      );
    };

    const formatDateTime = (value) => {
      if (!value) return "-";

      try {
        // Normalize the date string first
        let normalizedValue = value;

        // Handle single-digit hours in format "2025-3-7 8:23:54"
        if (
          /^\d{4}-\d{1,2}-\d{1,2} \d{1,2}:\d{1,2}(?::\d{1,2})?$/.test(value)
        ) {
          // Add leading zeros to single-digit hours, minutes, seconds
          normalizedValue = value.replace(
            /(\d{4})-(\d{1,2})-(\d{1,2}) (\d{1,2}):(\d{1,2}):?(\d{0,2})/,
            (match, y, M, d, H, m, s) => {
              const pad = (n) => n.padStart(2, "0");
              const sec = s ? `:${pad(s)}` : "";
              return `${y}-${pad(M)}-${pad(d)} ${pad(H)}:${pad(m)}${sec}`;
            },
          );
        }

        const date = new Date(normalizedValue);
        if (isNaN(date.getTime())) return value; // Return original if still invalid

        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();

        // Check if the original value was just a date (no time component)
        const isDateOnly = /^\d{4}-\d{1,2}-\d{1,2}$/.test(value.trim());

        if (isDateOnly) {
          return `${day}/${month}/${year}`;
        }

        // If it has time, include time in 24-hour format
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");

        return `${day}/${month}/${year} ${hours}:${minutes}`;
      } catch (e) {
        return value; // Return original if parsing fails
      }
    };

    if (latestStatusReportReport?.length > 0) {
      const keys = Object.keys(latestStatusReportReport[0]);
      const newColumns = keys.map((key) => ({
        field: key,
        headerName: key,
        align: "center",
        headerAlign: "center",
      }));

      const newRows = latestStatusReportReport.map((row, index) => {
        const processedRow = {};
        keys.forEach((key) => {
          const value = row[key];

          if (
            value === "" ||
            value === null ||
            value === "-" ||
            value === "--"
          ) {
            processedRow[key] = "-";
          } else if (isDate(value)) {
            processedRow[key] = formatDateTime(value);
          } else {
            processedRow[key] = value;
          }
        });

        return {
          id: index,
          ...processedRow,
        };
      });

      setColumns(newColumns);
      setDataRows(newRows);
    } else {
      setColumns([]);
      setDataRows([]);
    }
    setLocalLoading(false);
  }, [latestStatusReportReport]);

  useEffect(() => {
    const dropdownHeadings = document.querySelectorAll(".dropdown-heading");
    dropdownHeadings.forEach((heading: any) => {
      heading.style.height = "50px";
    });
  }, []);

  const handleTeamsChange = (event: any) => {
    const {
      target: { value },
    } = event;

    if (value.includes("all")) {
      setSelectedTeams(
        selectedTeams.length === optionsTeams.length
          ? []
          : optionsTeams.map((team) => team.value),
      );
    } else {
      // Convert the value to an array of strings
      setSelectedTeams(typeof value === "string" ? value.split(",") : value);
    }
  };

  useEffect(() => {
    setSelectedTeamsParam(selectedTeams);
  }, [selectedTeams]);

  const ITEM_HEIGHT = 60;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 150,
      },
    },
  };
  const isAllSelected = selectedTeams.length === optionsTeams.length;

  const handleWorkflowChange = (event: any) => {
    setSelectedWorkflowId(event.target.value);
  };

  const handleStatusChange = (event: any) => {
    const {
      target: { value },
    } = event;

    if (value.includes("all")) {
      setSelectedStatus(
        selectedStatus.length === optionsStatus.length
          ? []
          : optionsStatus.map((status) => status.value),
      );
    } else {
      // Convert the value to an array of strings
      setSelectedStatus(typeof value === "string" ? value.split(",") : value);
    }
  };

  const isAllStatusSelected = selectedStatus.length === optionsStatus.length;

  const handleDateFromChange = (event: any) => {
    setDateFrom(event.target.value);
  };

  const handleDateToChange = (event: any) => {
    setDateTo(event.target.value);
  };

  const handleSubmit = () => {
    if (!dateFrom) {
      toast.error('Please select "From Date"');
      return;
    }
    if (!dateTo) {
      toast.error('Please select "To Date"');
      return;
    }

    if (!selectedTeamsParam.length) {
      toast.error('Please select "Team"');
      return;
    }

    if (!selectedWorkflowId) {
      toast.error("Please select a workflow");
      return;
    }

    if (!selectedStatus.length) {
      toast.error("Please select a status");
      return;
    }
    const queryParams: any = {
      gte: dateFrom,
      lte: dateTo,
      status_type: "",
      workflow_id: selectedWorkflowId,
    };

    if (selectedTeamsParam.length > 1) {
      queryParams.team_ids = selectedTeamsParam; // Send as array
    } else if (selectedTeamsParam.length === 1) {
      queryParams.team_id = selectedTeamsParam[0]; // Send single team as team_id
    }

    if (selectedWorkflowId !== "All") {
      queryParams.workflow = selectedWorkflowId;
    }

    if (selectedStatus.length > 1) {
      queryParams.status_type = selectedStatus.join(",");
    } else if (selectedStatus.length === 1) {
      queryParams.status_type = selectedStatus[0];
    }

    setParams(queryParams);
    setLocalLoading(true); // Start loading when submitting
  };

  const handlePaginationChange = (newPaginationModel: any) => {
    setLocalLoading(true);
    setPaginationModel(newPaginationModel);
    setTimeout(() => {
      setLocalLoading(false);
    }, 1000);
  };

  const resetFilters = () => {
    setSelectedTeams([]);
    setSelectedWorkflowId(null);
    setDateFrom("");
    setDateTo("");
    setParams(null);
    setSelectedStatus([]);
    setDataRows([]);
  };

  if (error) {
    setLocalLoading(false);
  }

  return (
    <div id="kt_app_content_container" className="app-container mx-5">
      <div className="card card-flush">
        {/* Card Header */}
        <div
          className="card-header align-items-center py-1 gap-2 gap-md-5"
          style={{ justifyContent: "flex-start" }}
        >
          {/* <img
            src="https://insurance.circleonecrm.com/assets/arrow_back.svg"
            alt="Back"
            style={{ marginBottom: "-2px", cursor: "pointer" }}
            className="ng-star-inserted"
            onClick={() => navigate("/reports/ticket/reports-list")}
          /> */}
          <button
            className="btn btn-link mb-2"
            onClick={() => {
              navigate("/reports/ticket/reports-list");
            }}
            style={{ marginRight: "-17px" }}
          >
            <i
              className="bi bi-arrow-90deg-left"
              style={{
                fontSize: "20px",
                color: "black",
                cursor: "pointer",
              }}
            ></i>
          </button>
          <span className="fs-3 text-gray-800 fw-bold ms-3">
            Ticket status summary
          </span>
        </div>

        {/* Toolbar */}
        <div
          className="card-toolbar flex-row-fluid justify-content-start gap-5 d-flex mb-10"
          style={{ marginLeft: "30px" }}
        >
          {/* Date Filters */}
          <div className="w-100 mw-150px">
            <TextField
              id="date-from"
              label="From"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                inputProps: {
                  style: { textTransform: "uppercase" }, // Optional: uppercase input text
                  max: new Date().toISOString().split("T")[0],
                },
              }}
              fullWidth
              value={dateFrom}
              onChange={handleDateFromChange}
            />
          </div>
          <div className="w-100 mw-150px">
            <TextField
              id="date-to"
              label="To"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                inputProps: {
                  style: { textTransform: "uppercase" }, // Optional: uppercase input text
                  max: new Date().toISOString().split("T")[0],
                },
              }}
              fullWidth
              value={dateTo}
              onChange={handleDateToChange}
            />
          </div>
          <div className="w-100 mw-150px">
            <FormControl fullWidth>
              <InputLabel id="workflow-select-label">
                Select Workflow
              </InputLabel>
              <Select
                labelId="workflow-select-label"
                id="workflow-select"
                value={selectedWorkflowId || ""}
                onChange={handleWorkflowChange}
                label="Select Workflow"
                MenuProps={MenuProps}
              >
                {optionsWorkflow.map((workflow) => (
                  <MenuItem key={workflow.value} value={workflow.value}>
                    {workflow.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="w-100 mw-150px">
            <FormControl fullWidth>
              <InputLabel id="demo-multiple-checkbox-label">
                Select Teams
              </InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={selectedTeams}
                onChange={handleTeamsChange}
                input={<OutlinedInput label="Select Teams" />}
                renderValue={(selected) => {
                  if (isAllSelected) {
                    return <div>All</div>;
                  }
                  return (
                    <div>
                      {selected
                        .map((teamId) => {
                          const team = optionsTeams.find(
                            (t) => t.value === teamId,
                          );
                          return team ? team.label : null;
                        })
                        .join(", ")}
                    </div>
                  );
                }}
                MenuProps={MenuProps}
              >
                <MenuItem
                  value="all"
                  onClick={() =>
                    setSelectedTeams(
                      isAllSelected
                        ? []
                        : optionsTeams.map((team) => team.value),
                    )
                  }
                >
                  <Checkbox
                    checked={isAllSelected}
                    indeterminate={selectedTeams?.length > 0 && !isAllSelected}
                  />
                  <ListItemText primary="All" />
                </MenuItem>
                {optionsTeams.map((team) => (
                  <MenuItem key={team.value} value={team.value}>
                    <Checkbox
                      checked={selectedTeams.indexOf(team.value) > -1}
                    />
                    <ListItemText primary={team.label} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="w-100 mw-150px">
            <FormControl fullWidth>
              <InputLabel id="demo-multiple-checkbox-label">
                Select Status
              </InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={selectedStatus}
                onChange={handleStatusChange}
                input={<OutlinedInput label="Select Status" />}
                renderValue={(selected) => {
                  if (isAllStatusSelected) {
                    return <div>All</div>;
                  }
                  return (
                    <div>
                      {selected
                        .map((statusValue) => {
                          const status = optionsStatus.find(
                            (s) => s.value === statusValue,
                          );
                          return status ? status.label : null;
                        })
                        .join(", ")}
                    </div>
                  );
                }}
                MenuProps={MenuProps}
              >
                <MenuItem
                  value="all"
                  onClick={() =>
                    setSelectedStatus(
                      isAllStatusSelected
                        ? []
                        : optionsStatus.map((status) => status.value),
                    )
                  }
                >
                  <Checkbox
                    checked={isAllStatusSelected}
                    indeterminate={
                      selectedStatus?.length > 0 && !isAllStatusSelected
                    }
                  />
                  <ListItemText primary="All" />
                </MenuItem>
                {optionsStatus.map((status) => (
                  <MenuItem key={status.value} value={status.value}>
                    <Checkbox
                      checked={selectedStatus.indexOf(status.value) > -1}
                    />
                    <ListItemText primary={status.label} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div className="ms-auto d-flex gap-3" style={{ marginRight: "20px" }}>
            <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>
            <button
              className="btn btn-primary"
              onClick={handleDownloadClick}
              disabled={loading}
            >
              {loading ? (
                "Loading..."
              ) : (
                <CsvDownloader
                  filename="Ticket Status Summary"
                  datas={dataRows.map((row) => {
                    const safeRow: any = {};
                    Object.keys(row).forEach((k) => {
                      let val = row[k];
                      if (typeof val === "string") {
                        // Only escape double quotes
                        val = val.replace(/"/g, '""');
                      }
                      safeRow[k] = val;
                    });
                    return safeRow;
                  })}
                  columns={columns.map((col) => ({
                    id: col.field,
                    displayName: col.headerName,
                  }))}
                  separator=","
                  wrapColumnChar={`"`}
                >
                  Download
                </CsvDownloader>
              )}
            </button>
            <button className="btn btn-link" onClick={resetFilters}>
              <i className="bi bi-funnel fs-2 text-dark"></i>
            </button>
          </div>
        </div>

        {/* DataGrid */}
        <CardContent style={{ width: "100%" }}>
          {localLoading ? (
            <LoadingSpinner />
          ) : (
            <DataGrid
              rows={dataRows}
              columns={columns}
              pagination
              paginationModel={paginationModel}
              onPaginationModelChange={handlePaginationChange}
              disableColumnMenu
              pageSizeOptions={[5, 10, 15, 20]}
              localeText={{
                noRowsLabel: "No rows found",
              }}
              sx={{
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "lightgray",
                },
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "lightgray",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bold",
                  overflow: "visible",
                  whiteSpace: "normal",
                  textOverflow: "initial",
                  lineHeight: "normal",
                  textAlign: "center",
                },
                "& .MuiDataGrid-cell": {
                  textAlign: "center",
                },
                // Target the pagination select and actions by stable component classes
                "& .MuiTablePagination-select, .MuiTablePagination-actions": {
                  marginBottom: "10px",
                },
                // Target the DataGrid overlay wrapper with its stable class
                "& .MuiDataGrid-overlayWrapper": {
                  height: "50px",
                },
              }}
            />
          )}
        </CardContent>
      </div>
    </div>
  );
};

export default LatestStatusReport1;